// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wR17","rootNoMargin":"styles_rootNoMargin__1hUsW"};